import { trackEvent } from '@generated/server/analytics';

type EventType = Parameters<typeof trackEvent>[0]['data']['type'];

/** Fire-and-forget usage counter. Never blocks or breaks the UI. */
export function track(type: EventType, oncePerSession = false) {
  try {
    if (oncePerSession) {
      const key = `sr-track-${type}`;
      if (sessionStorage.getItem(key)) return;
      sessionStorage.setItem(key, '1');
    }
  } catch { /* storage blocked — still count */ }
  trackEvent({ data: { type } }).catch((e) => console.error('track failed', e));
}
